import { useClientPortalAPI } from "@certn/api";
import { useLocation } from "react-router-dom";
import { useSWRConfig } from "swr";

import { useQueryParams } from "./useQueryParams";
import { queryParamsToApiParams } from "../pages/tasks/utils";

export function useTasks() {
  const { clearParam, params, setParam } = useQueryParams();
  const { mutate } = useSWRConfig();
  const { pathname } = useLocation();

  const {
    data,
    isLoading,
    mutate: reload,
  } = useClientPortalAPI(
    "/api/internal/client-portal/tasks/list/",
    queryParamsToApiParams(
      params,
      pathname === "/tasks" ? "ACTIVE" : "COMPLETE"
    )
  );

  const handlePageChange = (page: number) => {
    setParam("page", page.toString());
  };

  const handlePageSizeChange = (pageCount: number) => {
    clearParam("page");
    setParam("page_size", pageCount.toString());
  };

  const handleTaskMutation = () => {
    reload();
    mutate("/api/internal/client-portal/me/tasks/?status=ACTIVE");
  };

  return {
    data,
    isLoading,
    params,
    handlePageChange,
    handlePageSizeChange,
    handleTaskMutation,
  };
}
